import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TEshopDM from './TEshopDM'
import TEshopCategoryInfoDM from './TEshopCategoryInfoDM'

export default class TEshopArticleCategorySummaryDM extends Data {
	public static className = 'TEshopArticleCategorySummaryDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	GroupAssignedOldId?: number
	IsArticleAssignedOld?: string
	GroupAssignedId?: number
	IsArticleAssigned?: string
	CategoryPath?: string
	ArticleId?: number
	RID?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	@Type(() => TEshopDM)
	EshopRID?: TEshopDM
	@Type(() => TEshopCategoryInfoDM)
	CategoryRIDCalc?: TEshopCategoryInfoDM
}